import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Auth } from 'aws-amplify';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const updateUserAccount = async body => {
	const url = `/auth/conta`;
	const response = await api.patch(url, body);
	return response.data;
};

export const useUpdateUserAccount = (setUserAttributes, setUserInfos) => {
	const toast = useToast();
	const queryClient = useQueryClient();

	return useMutation(updateUserAccount, {
		onSuccess: (sucess, variables) => {
			queryClient.invalidateQueries(['getUserAccount']);

			if (variables.senha) {
				localStorage.clear();
				Auth.signIn(variables?.email, variables.senha)
					.then(() => {
						window.location.reload();
					})
					.catch(error => {
						toast({
							title: 'Erro ao atualizar usuário(a).',
							description: `Algum erro ocorreu ao atualizar o usuário(a). ${error.message}`,
							position: 'bottom-left',
							status: 'error',
							duration: 8000,
							isClosable: true,
						});
					});
			} else {
				Auth.currentAuthenticatedUser()
					.then(async user => {
						await Auth.updateUserAttributes(user, {
							name: variables.nome,
						});
						// Aqui você pode acessar os atributos atualizados do usuário
						const updatedUser = await Auth.currentUserPoolUser();
						// Setando os atributos do usuário no estado global para não precisar fazer reload da página
						setUserAttributes(prevUserAttributes => ({
							...prevUserAttributes,
							name: updatedUser?.attributes?.name,
						}));
						setUserInfos(prevUserInfos => ({
							...prevUserInfos,
							membro_id: variables.membro_id,
						}));
					})
					.catch(error => {
						toast({
							title: 'Erro ao atualizar usuário(a).',
							description: `Algum erro ocorreu ao atualizar o usuário(a). ${error.message}`,
							position: 'bottom-left',
							status: 'error',
							duration: 8000,
							isClosable: true,
						});
					});
			}
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Usuário(a) atualizado(a) com sucesso!',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao atualizar usuário(a).'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
